import { render, staticRenderFns } from "./EditOrganizationProfile.vue?vue&type=template&id=3bb4edfd&scoped=true&"
import script from "./EditOrganizationProfile.vue?vue&type=script&lang=js&"
export * from "./EditOrganizationProfile.vue?vue&type=script&lang=js&"
import style0 from "./EditOrganizationProfile.vue?vue&type=style&index=0&id=3bb4edfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb4edfd",
  null
  
)

export default component.exports